// extracted by mini-css-extract-plugin
export default {"icon":"src-hellospa-icons-icons__icon--3vTqR"};